import React from "react";
import type { GalleryItem } from "../../data/gallery";
type ImageMarqueeProps = {
  items: GalleryItem[];
  onOpen: (id: string) => void;
};
function Row({
  items,
  reverse,
  duration,
  onOpen
}: {
  items: GalleryItem[];
  reverse?: boolean;
  duration: number;
  onOpen: (id: string) => void;
}) {
  const doubled = [...items, ...items];
  return <div className="mcc-marquee-row overflow-hidden" data-id="element-246" data-mp="3ioqqgai3dq4g">
      <div className={`mcc-marquee flex w-max gap-3 ${reverse ? "mcc-marquee-reverse" : ""}`} style={{
      ["--mcc-duration" as string]: `${duration}s`
    }} data-id="element-247" data-mp="3enyirlovbtaa">
        {doubled.map((item, i) => <button key={`${item.id}-${i}`} type="button" onClick={() => onOpen(item.id)} tabIndex={i >= items.length ? -1 : 0} aria-hidden={i >= items.length} aria-label={`Open ${item.caption}`} className="group relative h-48 shrink-0 overflow-hidden md:h-64" style={{
        width: item.shape === "wide" ? "26rem" : item.shape === "tall" ? "13rem" : "17rem"
      }} data-id="element-248" data-mp="34ozlez9jzk2l" data-mpi={i}>
            <img src={item.src} alt="" loading="lazy" className="h-full w-full object-cover transition-transform duration-500 ease-out group-hover:scale-105" data-id="element-249" data-mp="1la806mkqjypn" />
            <span className="absolute inset-x-0 bottom-0 translate-y-full bg-[#061f38]/85 px-4 py-3 text-left text-sm text-white transition-transform duration-300 ease-out group-hover:translate-y-0 group-focus-visible:translate-y-0" data-id="element-250" data-mp="1bb0mfya3a220">{item.caption}</span>
          </button>)}
      </div>
    </div>;
}
export function ImageMarquee({
  items,
  onOpen
}: ImageMarqueeProps) {
  const half = Math.ceil(items.length / 2);
  return <div className="space-y-3" data-id="element-251" data-mp="1u8jqenhowuhk">
      <Row items={items.slice(0, half)} duration={70} onOpen={onOpen} data-id="element-252" data-mp="1z7mtw3i0usnf" />
      <Row items={items.slice(half)} duration={80} reverse onOpen={onOpen} data-id="element-253" data-mp="1z5tkwhjxrwc9" />
    </div>;
}